import styles from "./standings.module.scss"
import { AppContext } from "../../../../utils/context"
import { useContext } from "react"

import { CosmosTitle } from "@cosmos/web-react"

import MaxLarge from "../../../../assets/images/graphics/max-standings.png"
import Max from "../../../../assets/images/graphics/max-driver.png"
import Isack from "../../../../assets/images/graphics/isack-driver.png"
import rb22Side from "../../../../assets/images/graphics/rb22-standings.png"

// Returns the HTML markup for the standings slide
export default function Standings() {
	// Pull the standings from the context
	const { standings, constructorStandings } = useContext(AppContext)

	// get constructor points for orbr
	const orbrPoints = constructorStandings?.find((team) => team.season_team_name === "Oracle Red Bull Racing")?.season_points || 0
	const orbrPosition = constructorStandings?.findIndex((team) => team.season_team_name === "Oracle Red Bull Racing") + 1 || 1

	// get Max's points and standings
	const maxPoints = standings?.find((driver) => driver?.last_name === "Verstappen")?.season_points || 0
	const maxPosition = standings?.findIndex((driver) => driver?.last_name === "Verstappen") + 1 || 1

	// get Isack's points and standings
	const isackPoints = standings?.find((driver) => driver?.last_name === "Hadjar")?.season_points || 0
	const isackPosition = standings?.findIndex((driver) => driver?.last_name === "Hadjar") + 1 || 2

	return (
		<div className={styles.container}>
			<CosmosTitle
				size="xx-large"
				className={styles.title}>
				CHAMPIONSHIP
				<br />
				STANDINGS
			</CosmosTitle>

			<img
				src={MaxLarge}
				className={styles.maxImg}
			/>

			<div className={styles.standingsContainer}>
				<div className={styles.constructors}>
					<CosmosTitle size="medium">P{orbrPosition}</CosmosTitle>
					<img src={rb22Side} />
					<CosmosTitle size="xx-large">{orbrPoints}</CosmosTitle>
				</div>

				<div className={styles.drivers}>
					<div className={styles.driver}>
						<div className={styles.info}>
							<div className={styles.position}>
								<CosmosTitle size="medium">P{maxPosition}</CosmosTitle>
							</div>
							<div className={styles.points}>
								<CosmosTitle size="xx-large">{maxPoints}</CosmosTitle>
							</div>
						</div>
						<img
							src={Max}
							className={`${styles.driverImg} ${styles.max}`}
						/>
					</div>

					<div className={styles.driver}>
						<div className={styles.info}>
							<div className={styles.position}>
								<CosmosTitle size="medium">P{isackPosition}</CosmosTitle>
							</div>
							<div className={styles.points}>
								<CosmosTitle size="xx-large">{isackPoints}</CosmosTitle>
							</div>
						</div>
						<img
							src={Isack}
							className={styles.driverImg}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
